export const istWords = [

  "guitar",
  "vocal",
  "pian",
  "harp",
  "solo",
  "lyric",
  "bass",
  "organ",

  // Creative
  "novel",
  "journal",
  "modern",
  "styl",
  "art",
  "surreal",
  "scient",
  "dent",
  "cartoon",
  "tattoo",
  "hairstyl",
"flor",





  // Personality
  "optim",
  "ideal",
  "special",
  "anarch",
  "human",
  "real",
  "activ",
  "cycl",
  "escap",
  "minimal",
  
  "real",
  "lingu",
  
  

  // Professional
  "public",
  "column",
  "copy",
  "mental",
  "physic",
  "biolog",
  

  // Add more categories and words as needed
];

export const getRandomWords = () => {
  const shuffled = [...istWords];
  shuffled[0] = "link"; // Always start with link
  
  // Shuffle rest of array
  for (let i = shuffled.length - 1; i > 1; i--) {
    const j = Math.floor(Math.random() * (i - 1)) + 1;
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
 
  // Insert "link" every 4th position
  for(let i = 4; i < shuffled.length; i += 4) {
    shuffled[i] = "link";
  }
 
  return shuffled;
 };
